var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tour',{ref:"tour",attrs:{"name":_vm.name,"steps":_vm.steps,"options":_vm.options,"callbacks":_vm.callbacks}})
}
var staticRenderFns = []

export { render, staticRenderFns }